import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, message, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { LoginCredentials } from '../types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AnimatedTrianglesBackground from '../components/AnimatedTrianglesBackground';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, login } = useAuth();

  // Перенаправляем авторизованных пользователей на главную
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  const onFinish = async (values: LoginCredentials) => {
    setLoading(true);
    try {
      const success = await login(values.username, values.password);
      if (success) {
        // Перенаправление произойдет автоматически через useEffect
      }
    } catch (error: any) {
      console.error('Login error:', error);
      message.error(error.response?.data?.detail || 'Ошибка входа в систему');
    } finally {
      setLoading(false);
    }
  };

  // Показываем загрузку, пока проверяется авторизация
  if (isLoading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <AnimatedTrianglesBackground />
        <Card style={{ width: 400, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', position: 'relative', zIndex: 1, backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin size="large" />
            <div style={{ marginTop: 16 }}>
              <Text type="secondary">Проверка авторизации...</Text>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <AnimatedTrianglesBackground />
      <Card style={{ width: 400, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', position: 'relative', zIndex: 1, backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
            Вход в систему
          </Title>
          <Text type="secondary">
            Введите ваши учетные данные
          </Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: 'Пожалуйста, введите имя пользователя!' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Имя пользователя"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Пожалуйста, введите пароль!' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Пароль"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              style={{ width: '100%' }}
            >
              Войти
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Text type="secondary">
            Демо доступ: admin / admin123
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Login; 